import requestApi from "@/utils/requestApi";
import NListGenerato from "@nxin/nxin-ui-pc/NListGenerato/NListGenerato.vue";
import ShopListDrawer from "@/components/shopListDrawer/shopListDrawer.vue";
import ClearingSetupDrawer from "@/components/clearingSetupDrawer/clearingSetupDrawer.vue";

export default {
  components: {
    ShopListDrawer,
    ClearingSetupDrawer,
    nListGenerato: NListGenerato,
  },

  data() {
    return {
      form: {
        shopNameLike: "",
        linkmanOrTelLike: "",
      },
      theadData: [
        {
          prop: "shopName",
          label: "供应商名称",
        },
        {
          prop: "linkman",
          label: "联系人",
        },
        {
          prop: "tel",
          label: "联系方式",
        },
        {
          prop: "updateBoName",
          label: "操作人",
        },
        {
          prop: "lastUpdateTime",
          label: "更新时间",
        },
        {
          prop: "fn",
          label: "操作",
          type: "custom",
        },
      ],
      tbodyData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchData: [
        {
          tag: "input",
          prop: "shopNameLike",
          value: "",
          label: "供应商名称",
        },
        {
          tag: "input",
          prop: "linkmanOrTelLike",
          value: "",
          label: "联系人",
          placeholder: "请输入姓名/手机号",
        },
      ],
      buttonFunctionData: [
        {
          tag: "button",
          icon: "el-icon-plus",
          prop: "add",
          type: "primary",
          label: "引入供应商",
        },
        {
          tag: "button",
          icon: "el-icon-download",
          prop: "export",
          type: "primary",
          label: "导出",
        },
      ],
    };
  },

  created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasesupplyinfo/selPage`, {
        ...this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      loading.close();

      if (code == "0") {
        this.total = Number(data.total);
        if (data.list.length == 0 && this.pageNum > 1) {
          this.pageNum = 1;
          this.loadData();
        } else {
          this.tbodyData = data.list;
        }
      } else {
        this.$message.error(msg);
      }
    },

    sizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadData();
    },
    currentChange(value) {
      if (typeof value === "number") {
        this.pageNum = value;
        this.loadData();
      }
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    searchSubmit(form) {
      this.form = form;
      this.pageNum = 1;
      this.loadData();
    },

    async handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasesupplyinfo/export`, this.form);
      loading.close();

      if (code == "0") {
        this.$open(data.url, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },

    supplierCreate() {
      this.$refs.shopListDrawer.open();
    },
    async supplierDel(id) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      const { msg, code } = await requestApi.post(`sctrading/purchase/purchasesupplyinfo/del`, {
        id,
      });
      loading.close();
      if (code == "0") {
        this.$message.success("操作成功");
        this.loadData();
      } else {
        this.$message.error(msg);
      }
    },
    async supplierConfirm(id) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      const { msg, code } = await requestApi.post(`sctrading/purchase/purchasesupplyinfo/add`, {
        supplierShopId: id,
      });
      loading.close();

      if (code == "0") {
        this.$message.success("引入成功");
        this.pageNum = 1;
        this.loadData();
      } else {
        this.$message.error(msg);
      }
    },
    async clearingSetupConfirm(form) {
      console.log("clearingSetupConfirm-form", form);
    },
  },
};
